module.exports = __webpack_public_path__ + "static/media/temperature-high.a23e0aa1.svg";